<template>
  <div class="page-container">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>blockInfo</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">扫块管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>blockInfo</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
       
        <el-select v-model="isFinished" placeholder="请筛选完成状态" clearable>
          <!-- <el-option>全部</el-option> -->
          <el-option
            v-for="item in isFinishedOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="mark" placeholder="请筛选内部状态" clearable>
          <!-- <el-option>全部</el-option> -->
          <el-option
            v-for="item in innerStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <user-list @refresh="refreshList" ></user-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions, mapMutations } from 'vuex';
import { QUERY_TYPE, PAGINATION } from './constants';

export default {
  name: 'BlockInfo',
  components: {
    UserList
  },
  data() {
    return {
      mark: '',
      isFinished:'',
      status: [{ value: 0, label: '激活' }, { value: '-1', label: '冻结' }],
      isFinishedOption: [{ value: true, label: '完成' }, { value: false, label: '未完成' }],
      innerStatus:[
        { value: 'SUCCESS', label: '成功' },
        { value: 'FAIL', label: '失败' },
        { value: 'EXECUTING_DISPOSE', label: '正在执行中' },
        { value: 'FAIL_CANNOT_RETRY ', label: '失败不能重试' },
        { value: 'REPEAT_CANNOT_RETRY', label: '重复不能重试' },
        { value: 'UNSUPPORTED_TRANSACTION', label: '不支持此交易' },
        { value: 'WAITING_FOR_CONFIRMATION', label: '等待确认中' },
      ]
    };
  },
  computed: {
    ...mapState('blockInfo', ['pagination'])
  },
  methods: {
    ...mapActions('blockInfo', ['list','getBlockInfoList']),
    // ...mapMutations('blockInfo', ['setQueryType']),
    refreshList(data = {}) {
      this.getBlockInfoList({
        isFinished:this.isFinished,
      disposeStatusInner:'',
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      
      this.getBlockInfoList({
        isFinished:this.isFinished,
      disposeStatusInner:this.mark,
        ...PAGINATION
      });
    }
  },
  created() {
    this.getBlockInfoList({
      isFinished:'',
      disposeStatusInner:'',
      ...PAGINATION
    });
  }
};
</script>

<style lang="less" scoped>
  .page-actions{
    margin-bottom: 10px;
  }
</style>
